import { ViteReactSSG } from 'vite-react-ssg';
// Self-hosted variable fonts (served from our origin → CSP-safe, no external request)
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import { routes } from './routes';

export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient }) => {
    // Sentry is browser-only — init it on the client, never during prerender.
    if (isClient) {
      // Destructured so Rollup can tree-shake the rest of @sentry/react out of the chunk.
      import('@sentry/react').then(({ init, browserTracingIntegration }) => {
        init({
          dsn: 'https://4aa3fa0ca8c51e711ffe9698b79642e3@o4510840796938240.ingest.us.sentry.io/4510845186801664',
          integrations: [browserTracingIntegration()],
          tracesSampleRate: 0.1,
          enabled: import.meta.env.PROD,
        });
      });
    }
  },
);
